import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { BillingAccount, BillingAccountCreate, BillingAccountFilter } from '../data/billingAccount';

export function createBillingAccountService(client: AxiosInstance) {
  return createCrudService<BillingAccount, BillingAccountCreate, BillingAccountFilter>(
    client,
    '/tenancy/BillingAccount',
    'id',
  );
}

export type BillingAccountService = CrudService<BillingAccount, BillingAccountCreate, BillingAccountFilter>;
